module.exports = __webpack_public_path__ + "static/media/section-bg.d9d7462b.svg";